import { useCallback } from 'react';

import { track } from '@adsk/acs-web-analytics';
import { useCurrentProductId, useCurrentToolId } from '@adsk/alloy-provider';

const useContextualTrack = () => {
  const currentToolId = useCurrentToolId();
  const currentProductId = useCurrentProductId();

  /**
   * Track an event with the current tool and product IDs
   */
  const contextualTrack = useCallback(
    (eventName: string, data: Record<string, unknown>) => {
      track(eventName, {
        tool_id: currentToolId,
        product_id: currentProductId,
        ...data,
      });
    },
    [currentToolId, currentProductId],
  );

  return {
    contextualTrack,
  };
};

export default useContextualTrack;
